export const FONT_CATALOGUE = [
    {
        label: "Cormorant Garamond",
        stack: '"Cormorant Garamond", Georgia, serif',
        category: "serif",
    },
    {
        label: "Instrument Serif",
        stack: '"Instrument Serif", Georgia, serif',
        category: "serif",
    },
    {
        label: "Newsreader",
        stack: '"Newsreader", Georgia, serif',
        category: "serif",
    },
    { label: "Spectral", stack: '"Spectral", Georgia, serif', category: "serif" },
    {
        label: "Marcellus",
        stack: '"Marcellus", Georgia, serif',
        category: "serif",
    },
    {
        label: "Inter Tight",
        stack: '"Inter Tight", system-ui, sans-serif',
        category: "sans",
    },
    {
        label: "DM Sans",
        stack: '"DM Sans", system-ui, sans-serif',
        category: "sans",
    },
    { label: "Jost", stack: '"Jost", system-ui, sans-serif', category: "sans" },
    {
        label: "Figtree",
        stack: '"Figtree", system-ui, sans-serif',
        category: "sans",
    },
    {
        label: "Work Sans",
        stack: '"Work Sans", system-ui, sans-serif',
        category: "sans",
    },
    {
        label: "Space Grotesk",
        stack: '"Space Grotesk", system-ui, sans-serif',
        category: "sans",
    },
    {
        label: "Manrope",
        stack: '"Manrope", system-ui, sans-serif',
        category: "sans",
    },
    { label: "Onest", stack: '"Onest", system-ui, sans-serif', category: "sans" },
    {
        label: "JetBrains Mono",
        stack: '"JetBrains Mono", ui-monospace, monospace',
        category: "mono",
    },
    {
        label: "Geist Mono",
        stack: '"Geist Mono", ui-monospace, monospace',
        category: "mono",
    },
    {
        label: "Space Mono",
        stack: '"Space Mono", ui-monospace, monospace',
        category: "mono",
    },
];
export function fontOptionForStack(stack) {
    var _a;
    if (!stack)
        return null;
    return (_a = FONT_CATALOGUE.find((f) => f.stack === stack)) !== null && _a !== void 0 ? _a : null;
}
